import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { stylesConstants } from '../../styles/stylesConstants';

export default makeStyles((theme: Theme) => ({
  checkboxColumn: {
    margin: `0px ${theme.spacing(4)}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  row: {
    height: stylesConstants.checkboxGridRowHeight,
    display: 'flex',
    alignItems: 'center',
  },
}));
